export const COMMAND_SETTING_ID: number = 10788;
export const DASHBOARD_PROFILE_ID: number = 45;
export const LIVE_SETTING_ID: number = 10726;
export const SHORTCUT_SETTING_ID: number = 10894;
export const SITE_COMMANDS: string = "SITE_COMMANDS";
export const CONTROLLER_COMMANDS: string = "CONTROLLER_COMMANDS";
export const READER_COMMANDS: string = "READER_COMMANDS";
export const LOCATION_COMMANDS: string = "LOCATION_COMMANDS";
export const ZONE_COMMANDS: string = "ZONE_COMMANDS";
export const Y_POSITION: string = "POSITION_COLUMN_INDEX_1";
export const X_POSITION: string = "POSITION_ROW_INDEX_1";
export const TITLE_BKGCOLOR: string = "TITLE_BKGCOLOR";
export const TITLE_FGCOLOR: string = "TITLE_FGCOLOR";
export const QUICK_ENROLL_BKGCOLOR: string = "QUICK_ENROLL_BKGCOLOR";
export const UI_ELEMENT_SELECT_MENU_ITEM: string = "UI_ELEMENT_SELECT_MENU_ITEM";

export const WIDGET_TYPES = {
    COMMANDS_WIDGET: "COMMANDS_WIDGET",
    LIVE_TRANSACTIONS_WIDGET: "LIVE_WIDGET",
    SHORTCUT_WIDGET: "SHORTCUT_WIDGET",
    QUICK_ENROLL_WIDGET: "QUICK_ENROLL"
}

export const WIDGET_DIMENSION: { sEventSysname: string, width: number, height: number}[] = [
    { sEventSysname: WIDGET_TYPES.COMMANDS_WIDGET, width: 2.72, height: 10.1 },
    { sEventSysname: WIDGET_TYPES.LIVE_TRANSACTIONS_WIDGET, width: 7.7, height: 29 },
    { sEventSysname: WIDGET_TYPES.SHORTCUT_WIDGET, width: 1.45, height: 6 },
    { sEventSysname: WIDGET_TYPES.QUICK_ENROLL_WIDGET, width: 1.45, height: 6 },
]

export const COMMAND_SUB_TYPES = {
    OPEN_DOOR: "OPEN_DOOR",
    EMERGENCY_MODE: "EMERGENCY_MODE",
    LOCKDOWN_MODE: "LOCKDOWN_MODE",
    APB_RESET: "APB_RESET"
}
export const COMMAND = "DEVICE"
export const ENABLE_STATE = "ENABLE";
export const DISABLE_STATE = "DISABLE";

export const CATEGORY_TYPES = {
    VEHICLE: "VEHICLE",
    TAGHOLDER: "TAGHOLDER",
    VISITOR: "VISITOR"
}

export const CONTROL_PANEL_WIDGET_BUTTONS = {
    COMMAND: 'COMMAND',
    QUICK_ENROL: 'QUICK_ENROL',
    MONITOR_COMMS: 'MONITOR_COMMS',
    MONITOR_DOOR: 'MONITOR_DOOR',
    PERSON_TRACKER: 'PERSON_TRACKER',
    LIVE_TRANSACTIONS: 'LIVE_TRANSACTIONS',
    SHORTCUT: 'SHORTCUT',
}

export const QUICK_ENROL_SETTING_ID = '10799'

interface widgetColors {
    TITLE_BKGCOLOR: string,
    TITLE_FGCOLOR: string,
}

const defaultColors = () : widgetColors => {
    const env =  import.meta.env.VITE_BRAND_PATH;

    switch (env) {
        case "impro": {
            return {
                TITLE_BKGCOLOR: "#0154F0",
                TITLE_FGCOLOR: "#FFFFFF",
            }
        }

        case "pmt": {
           return {
                TITLE_BKGCOLOR: "#d52028",
                TITLE_FGCOLOR: "#FFFFFF",
            }
        }

        default: {                 
            return {
                TITLE_BKGCOLOR: "#0154F0",
                TITLE_FGCOLOR: "#FFFFFF",
            }
        }
    }

}

export const DEFAULT_WIDGET = {
    TITLE_BKGCOLOR: defaultColors().TITLE_BKGCOLOR,
    TITLE_FGCOLOR: defaultColors().TITLE_FGCOLOR,
    X_POSITION: 0,
    Y_POSITION: 0,
    FOREGROUND_COLOR: "#cbd5e0",
}
